export const numeralLocaleConfigFr = {
    delimiters: {
        thousands: ' ',
        decimal: ',',
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't',
    },
    ordinal: (num) => {
        return num === 1 ? 'er' : 'e';
    },
    currency: {
        symbol: '€',
    },
};
